export const T = {
  en_GB: {
    title: "Total value",
    allAccounts: (currency: string) => `All accounts, week by week, in ${currency}`,
    someAccounts: (currency: string) => `Accounts with value history, week by week, in ${currency}`,
    basedOn: (included: number, total: number) => `Based on ${included} of ${total} accounts`,
    asOf: (date: string) => `as of ${date}`,
  },
  nb_NO: {
    title: "Total verdi",
    allAccounts: (currency: string) => `Alle kontoer, uke for uke, i ${currency}`,
    someAccounts: (currency: string) => `Kontoer med verdihistorikk, uke for uke, i ${currency}`,
    basedOn: (included: number, total: number) => `Basert på ${included} av ${total} kontoer`,
    asOf: (date: string) => `per ${date}`,
  },
} as const;
